import { Permission } from "../../types";
import { deepClone } from "../../utils/helpers";

/**
 * Prepare permissions for database operations by cleaning/transforming data
 */
export const preparePermissionsForSave = (permissions: Permission[]): any[] => {
  // Make a deep clone to prevent mutation issues
  const permissionsToSave = deepClone(permissions);
  
  // Extract everything EXCEPT the id field for new records
  return permissionsToSave.map(permission => {
    // If it's a numeric ID (from defaults), remove it completely
    if (typeof permission.id === 'number' || permission.id?.toString().length < 10) {
      const { id, ...rest } = permission;
      return rest;
    }
    // Otherwise keep the existing UUID
    return permission;
  });
};
